import React from 'react';
import {
    TwitterShareButton, TwitterIcon, FacebookShareButton, FacebookIcon, RedditShareButton, RedditIcon, LinkedinShareButton, LinkedinIcon, TumblrShareButton, TumblrIcon
} from 'react-share';

class SocialMediaButtons extends React.Component{
    render(){
        return <div className="socialMediaButtons">
            <TwitterShareButton
                url={this.props.shareUrl}
                title={`Check out the trends for ${this.props.shareTitle}`}
                hashtags={["handymaps"]}>
                <TwitterIcon
                    size={32}
                />
            </TwitterShareButton>
            <FacebookShareButton
                url={this.props.shareUrl}
                quote={`Check out the trends for ${this.props.shareTitle}`}>
                <FacebookIcon
                    size={32}
                />
            </FacebookShareButton>
            <RedditShareButton
                url={this.props.shareUrl}
                title={`Check out the trends for ${this.props.shareTitle}`}>
                <RedditIcon
                    size={32}
                />
            </RedditShareButton>
            <TumblrShareButton
                url={this.props.shareUrl}
                title={`Check out the trends for ${this.props.shareTitle}`}>
                <TumblrIcon
                    size={32}
                />
            </TumblrShareButton>
            <LinkedinShareButton
                url={this.props.shareUrl}>
                <LinkedinIcon
                    size={32}
                />
            </LinkedinShareButton>
        </div>;
    }
}

export default SocialMediaButtons;